export function stripSchemeAndPort(url) {
    let result = url;
    if (url.startsWith('https')) {
        result = url.substring(8, url.length);
    } else if (url.startsWith('http')) {
        result = url.substring(7, url.length);
    }

    const colonIndex = result.lastIndexOf(':');
    if (colonIndex >= 0) {
        result = result.substring(0, colonIndex)
    }

    return result;
}
